






import { Component, Mixins } from "vue-property-decorator";
import { DeveloperPresentableMixin } from "./mixins";

@Component({
  components: {
  }
})
export default class QuitDeveloperView extends Mixins(DeveloperPresentableMixin) {
  mounted(): void {
    this.isDeveloperMode = false;
  }
}
